import React from 'react';
import './Header.css';

function Header({ user, onLogout, onEditProfile, version }) {
  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          <img
            src="/logo_dargency.jpg"
            alt="DARGENCY"
            className="logo-image"
          />
        </div>

        <div className="header-center">
          <span className="logo-title">AssurExtract</span>
          {version && (
            <span style={{ fontSize: '10px', color: '#64748b', marginLeft: '8px', fontWeight: '400' }}>v{version}</span>
          )}
        </div>

        <div className="header-right">
          {user && onLogout && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <button
                onClick={onEditProfile}
                style={{
                  background: 'rgba(255,255,255,0.08)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '20px',
                  color: '#e2e8f0',
                  padding: '6px 14px 6px 10px',
                  fontSize: '13px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.2s'
                }}
                title="Modifier mon profil"
              >
                <span style={{
                  width: '26px',
                  height: '26px',
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #3b82f6, #8b5cf6)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: '700',
                  color: '#fff',
                  letterSpacing: '0.5px'
                }}>
                  {(user.prenom?.[0] || '').toUpperCase()}{(user.nom?.[0] || '').toUpperCase()}
                </span>
                <span style={{ color: '#a78bfa', fontWeight: '600' }}>
                  {user.prenom || user.email}
                </span>
              </button>
              <button
                onClick={onLogout}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#64748b',
                  padding: '8px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  transition: 'color 0.2s',
                  borderRadius: '8px'
                }}
                title="Déconnexion"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                  <polyline points="16 17 21 12 16 7"/>
                  <line x1="21" y1="12" x2="9" y2="12"/>
                </svg>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
